import React from "react";
import { useTranslation } from "react-i18next";
import { Download } from "lucide-react";
import { exportToCsv } from "@/charts/tableUtils";
import "@/charts/TableChart.css";

/**
 * Reusable table title bar with a CSV export button.
 *
 * Props:
 *   title       - string or React element displayed as the table heading.
 *   exportTitle - optional plain string used as the CSV filename. Falls back to
 *                 `title` when not provided (only works if title is a string).
 *   data        - array of row objects (the full dataset, not paginated).
 *   columns     - array of { key, title } describing which columns to export.
 *   exportData  - optional override dataset used for the CSV (plain-string rows).
 *                 Falls back to `data` when not provided.
 */
const TableTitleBar = ({ title, exportTitle, data, columns, exportData }) => {
  const { t } = useTranslation();
  const handleExport = () =>
    exportToCsv(exportData ?? data, columns, exportTitle ?? title);

  const exportLabel = t("common.exportCsv", "Export to CSV");

  return (
    <div className="px-3 py-2 border-bottom bg-light d-flex justify-content-between align-items-center">
      <div className="text-sm fw-medium text-dark">{title}</div>
      <button
        type="button"
        onClick={handleExport}
        className="table-export-btn"
        title={exportLabel}
        aria-label={exportLabel}
      >
        <Download size={15} />
      </button>
    </div>
  );
};

export default TableTitleBar;
